var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { connectComponent } from "../../redux/utils";
import auth from "../../redux/action/auth";
import { apiGet } from "../../api";
import { CONSTANTS } from "../../constants";
import { Redirect } from "react-router-dom";
var Authorize = /** @class */ (function (_super) {
    __extends(Authorize, _super);
    function Authorize(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            authorized: false,
            redirectUrl: null
        };
        return _this;
    }
    Authorize.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, actions, subsystemId, params, accessToken, refreshToken, userId, firstName, lastName, redirectUrl, token, user, privileges;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, actions = _a.actions, subsystemId = _a.subsystemId;
                        params = new URLSearchParams(window.location.search);
                        accessToken = params.get("accessToken");
                        refreshToken = params.get("refreshToken");
                        userId = params.get("userId");
                        firstName = params.get("firstName");
                        lastName = params.get("lastName");
                        redirectUrl = params.get("redirectUrl");
                        token = { accessToken: accessToken, refreshToken: refreshToken, userId: userId, firstName: firstName, lastName: lastName };
                        localStorage.setItem("token", JSON.stringify(token));
                        return [4 /*yield*/, apiGet(CONSTANTS.authUrl + '/api/check')];
                    case 1:
                        user = _b.sent();
                        return [4 /*yield*/, apiGet(CONSTANTS.authUrl + '/api/check/privilege/' + subsystemId)];
                    case 2:
                        privileges = _b.sent();
                        actions.setState({ user: user, privileges: privileges });
                        this.setState({
                            authorized: true,
                            redirectUrl: redirectUrl
                        });
                        if (redirectUrl) {
                            window.location.replace(redirectUrl);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Authorize.prototype.render = function () {
        var _a = this.state, authorized = _a.authorized, redirectUrl = _a.redirectUrl;
        if (authorized && !redirectUrl) {
            return React.createElement(Redirect, { to: '/' });
        }
        else {
            return null;
        }
    };
    return Authorize;
}(Component));
export default connectComponent(function (state) { return ({
    subsystemId: state.auth.subsystem.subsystemId
}); }, function (dispatch) { return ({
    actions: auth(dispatch)
}); }, Authorize);
//# sourceMappingURL=Authorize.js.map